/**
 * Helper functions for extracting report parameters from Redux state
 * These helpers remove the need to pass ban and crmId explicitly
 */

/**
 * Get common report parameters from Redux state and subscriber
 * @param {Object} selectedSubscriber - The selected subscriber from FuntoneSlice
 * @param {Object} loginData - Login data from authentication state
 * @returns {Object} Common report parameters (subscriber, customerName, id)
 */
export function getCommonReportParams(selectedSubscriber, loginData) {
  const subscriber = selectedSubscriber?.cli || '';
  const firstName = selectedSubscriber?.firstName || '';
  const lastName = selectedSubscriber?.lastName || '';
  const customerName = selectedSubscriber?.fullName || `${firstName} ${lastName}`.trim() || '';
  const id = loginData?.userDetails?.idNumber || loginData?.userDetails?.id || '';
  
  return {
    subscriber,
    customerName,
    id,
  };
}
